import type { ComponentProps } from 'react'
import EmergencyNotes from '../../shared/EmergencyNotes'

type EmergencyNotesProps = ComponentProps<typeof EmergencyNotes>

/**
 * Step 4: Emergency Notes
 * Wrapper for shared EmergencyNotes component
 */
export default function Step4_EmergencyNotes(props: EmergencyNotesProps) {
  return <EmergencyNotes {...props} />
}
